import Model from '../../ModelBinding/Model';
import OrganizationResolvedBillingInfoCollection from './OrganizationResolvedBillingInfoCollection';
import dayjs from 'dayjs';
import Address from '../Address/Address';

export default class OrganizationResolvedBillingInfo extends Model {
  public legal_name?: string;
  public legal_status?: string;
  public tax_id?: string;
  public vat_rate?: number;
  public payment_term?: number;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public address?: Address;
  public currency?: string;

  bind() {
    this.legal_name = this.getStringAttribute('legal_name');
    this.legal_status = this.getStringAttribute('legal_status');
    this.tax_id = this.getStringAttribute('tax_id');
    this.vat_rate = this.getIntAttribute('vat_rate');
    this.payment_term = this.getIntAttribute('payment_term');
    this.address = this.getRelation('address', Address) as Address;
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.currency = this.getStringAttribute('currency');
  }

  static getCollection() {
    return OrganizationResolvedBillingInfoCollection;
  }
}
